webpackJsonp([243407284051199],{

/***/ 627:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/projects/a-le-coq-limpa-tvc.md absPath of file >>> MarkdownRemark","html":"","excerpt":"","tags":["AI"],"frontmatter":{"date":"August 31, 2026","title":"LIMPA 90","videoUrl":"https://vimeo.com/1189443391?share=copy&fl=sv&fe=ci","image":"/img/thumb.jpg","credits":null}}},"pathContext":{"id":"/opt/build/repo/src/pages/projects/a-le-coq-limpa-tvc.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---projects-a-le-coq-limpa-tvc-a4c8f431037a76d4558d.js